module.exports = __webpack_public_path__ + "static/media/cp9in.31aa74d3.png";